import React, { FC } from 'react';
import { OrderPartsImg } from '@root/app/react/uikit';
import { useMediaDesktop } from '@app/react/common/useMedia';
import { MozikokuinBodyDesktopComponent } from '@component/PartsSelectComponent/MozikokuinBodyDesktopComponent';
import { MozikokuinBodyMobileComponent } from '@component/PartsSelectComponent/MozikokuinBodyMobileComponent';
import { OrderSelectBaseLayout } from '@component/OrderSelectBaseLayout';
import { OrderPartsHelpCarving } from '@component/OrderPartsHelp';
import { PartsProduct } from '@app/react/const/type';

const partsNameProps = '文字刻印';

interface OrderMozikokuinComponentProps {
    onOk: () => void;
    onCustomizeClick: () => void;
    status: boolean;
    onChangeStatus: (value: boolean) => void;
    viewData: Array<PartsProduct>;
    selectedProduct: any | null;
    onSelectProduct: (product: PartsProduct) => void;
    carvingString: string | null;
    onChangeText: React.ChangeEventHandler<HTMLInputElement>;
    noProduct: PartsProduct;
    yesProduct: PartsProduct;
    isHelpOpen: boolean;
    handleHelpOpen: () => void;
    handleHelpClose: () => void;
}

export const OrderMozikokuinComponent: FC<OrderMozikokuinComponentProps> = (props) => {
    const {
        onOk,
        onCustomizeClick,
        status,
        onChangeStatus,
        viewData,
        selectedProduct,
        onSelectProduct,
        carvingString,
        onChangeText,
        noProduct,
        yesProduct,
        isHelpOpen,
        handleHelpOpen,
        handleHelpClose,
    } = props;

    const isDesktop = useMediaDesktop();

    const bodyComponent = isDesktop ? (
        <MozikokuinBodyDesktopComponent
            status={status}
            toggleStatus={onChangeStatus}
            viewData={viewData}
            selectedProduct={selectedProduct}
            onSelectProduct={onSelectProduct}
            carvingString={carvingString}
            onChangeText={onChangeText}
            noProduct={noProduct}
            yesProduct={yesProduct}
        />
    ) : (
        <MozikokuinBodyMobileComponent
            status={status}
            toggleStatus={onChangeStatus}
            viewData={viewData}
            selectedProduct={selectedProduct}
            onSelectProduct={onSelectProduct}
            carvingString={carvingString}
            onChangeText={onChangeText}
            onOk={onOk}
            onCustomizeClick={onCustomizeClick}
            noProduct={noProduct}
            yesProduct={yesProduct}
        />
    );

    return (
        <>
            <OrderSelectBaseLayout
                type={1}
                header={isDesktop && (
                    <OrderPartsImg
                        partsName={partsNameProps}
                        showHelpBtn
                        onHelpClick={handleHelpOpen}
                    />
                )}
                body={bodyComponent}
            />
            <OrderPartsHelpCarving
                isOpen={isHelpOpen}
                handleOpen={handleHelpOpen}
                handleClose={handleHelpClose}
            />
        </>
    );
};
